import React from 'react'
import ReactDOM from 'react-dom'
import { navigateTo } from 'gatsby-link'
import styled, { injectGlobal } from 'styled-components'
import ScrollBackground from 'react-scrolling-color-background'

import { isClient } from '../../styles/utils'

class ScrollBg extends React.Component {

	state = {
		pageLoaded: false,
		key: 1
	}
		
	componentDidMount() {
		setTimeout(() => {
			this.setState({
				pageLoaded: true
			})
		}, 0);
	}

	componentDidUpdate = (prevProps, prevState) => {
		if (prevProps.location.pathname !== this.props.location.pathname) {
			const scrollBG = ReactDOM.findDOMNode(this.refs.scrollBG);

			if (scrollBG) {
				//console.log(scrollBG.style.backgroundColor)
				scrollBG.style.backgroundColor = 'rgb(255, 255, 255)'
			} 
			
			let self = this;

			setTimeout(() => {
				self.setState({
					key: this.state.key + 1
				})
			}, 0);
		
		}	
	}
	
	render() {
		const { pageLoaded, key } = this.state;
		const { location } = this.props;

		let settings = {
			selector: '[data-colour]',
			colorDataAttribute: 'data-colour',
			initialRgb: 'rgb(255, 255, 255)'
		}

		if (location.pathname.includes('/journal')) {
			settings.style = {
				display: 'none'
			}
		}

		let sections;
		
        if (isClient()) {
            sections = document.querySelectorAll('[data-colour]');
		}
		
		return (
			<React.Fragment>
				{pageLoaded && sections.length > 1 && (
					<ScrollBackground
						key={key}
						ref={'scrollBG'}
						{...settings}
					/> 
				)}
			</React.Fragment>
		)
	}
}

export default ScrollBg



// WEBPACK FOOTER //
// ./src/components/ScrollBackground/ScrollBackground.js